module.exports = __webpack_public_path__ + "img/6.bf711313.png";